import { useEffect, useState } from 'react';

export default function useFetchGet<T>(url: string, accessToken?: string): T | null {
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      try {
        const response = await fetch(url, {
          headers: accessToken ? { authorization: `Bearer ${accessToken}` } : undefined,
          signal,
        });
        const json = (await response.json()) as T;
        setData(json);
      } catch (e) {
        if (e instanceof DOMException) {
          // Fetch aborted by us, do nothing
        } else {
          throw e;
        }
      }
    };
    fetchData();

    return () => {
      controller.abort();
    };
  }, [url, accessToken]);

  return data;
}
